import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelButton} from "../../../layout/rightSidebar/RightSidebarRail";
import SortPanel from "../components/SortPanel";
import {useServerTableContext} from "../ServerTableContext";

export function ServerTableRailSort() {
    const {t} = useTranslation();
    const {table} = useServerTableContext();
    const hasSortableColumn = table.getAllLeafColumns()
        .some(column => column.columnDef.meta?.isServerSortable === true);

    if (!hasSortableColumn) return null;

    return (
        <RightSidebarPanelButton
            icon={<SwapVertOutlinedIcon/>}
            label={t("Sort")}
            renderPanel={close => (
                <RightSidebarFloatingPanel>
                    <SortPanel table={table} onClose={close}/>
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
